import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  constructor() {
  }

  public getCookie(name: string) {
    const cookieArray: Array<string> = document.cookie.split(';');
    const cookieName = encodeURIComponent(name) + '=';
    const cookie = cookieArray
      .find(cookieValue => cookieValue.replace(/^\s+/g, '').indexOf(cookieName) === 0);
    return cookie ? decodeURIComponent(cookie.trim().substring(cookieName.length, cookie.length)) : '';
  }

  public deleteCookie(name: string, path: string = '') {
    this.setCookie(name, '', -1, path);
  }

  public setCookie(name: string,
                   value: string,
                   expires: number | Date,
                   path?: string,
                   domain?: string,
                   secure?: boolean,
                   sameSite: string = 'Strict') {

    let cookieString: string = encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';';

    if (typeof expires === 'number') {
      const expireDate: Date = new Date();
      expireDate.setTime(expireDate.getTime() + expires * 24 * 60 * 60 * 1000);
      cookieString += `expires=${expireDate.toUTCString()};`;
    } else {
      cookieString += `expires=${expires.toUTCString()};`;
    }

    if (path) {
      cookieString += `path=${path};`;
    }

    if (domain) {
      cookieString += `domain=${domain};`;
    }

    if (secure) {
      cookieString += `secure=${secure};`;
    }

    cookieString += `SameSite=${sameSite};`;
    document.cookie = cookieString;
  }
}
